import AjaxRequest from './AjaxRequest'

export default class User {
    verify(data) {
        return new AjaxRequest().post(`auth/verify`, data)
    }

    checkVerified(data) {
        return new AjaxRequest().get(`auth/verified`, data)
    }

    register(data) {
        return new AjaxRequest().post(`auth/register`, data)
    }

    sendResetLink(data) {
        return new AjaxRequest().post(`auth/password/reset`, data)
    }

    updatePassword(data) {
        return new AjaxRequest().post(`auth/password/update`, data)
    }

    resendVerificationEmail(data) {
        return new AjaxRequest().post(`user/verification/resend`, data)
    }

    // userGuid(data) {
    //     return new AjaxRequest().get(`findphotos`, data)
    // }
    userGuid(data) {
        return new AjaxRequest().get(`auth/user-guid`, data)
    }

    saveProfile(data) {
        return new AjaxRequest().patch(`/user/${data.user_id}/profile`, data)
    }
}
